define('ssd_homepageextension_homepageextension.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('ssd_homepageextension_homepageextension', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true}, 'extensions/SSD/HomepageExtension/2.0.0/', 'extensions/SSD/HomepageExtension/2.0.0/', Handlebars);
});